import React from 'react';
import PropTypes from 'prop-types';

class ClientComponents extends React.PureComponent {
  static propTypes = {
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
    loaderComponent: PropTypes.object,
  };

  state = { isClient: false };

  componentDidMount() {
    this.setState({ isClient: true });
  }

  render() {
    const { children, loaderComponent } = this.props;
    const { isClient } = this.state;

    if (children && isClient)
      return typeof children === 'function' ? children() : children;

    return loaderComponent || null;
  }
}

export default ClientComponents;
